import MapView from '@arcgis/core/views/MapView';
import React from 'react';

export const MIN_ZOOM = 3;
export const MAX_LATLNG = 180;

export type MapComponent = {
  element: (view: MapView | undefined) => Element | React.ReactNode,
  key: string,
}
export interface MapPlugin {
  name?: string,
  component?: MapComponent,
  initMap?: (mapView: MapView) => void,
  extendMap?: (mapView: MapView, deckLayer?) => void,
  onChange?: (mapView: MapView) => void,
}

export enum MapPlacement {
  TopLeft = 'top-left',
  TopRight = 'top-right',
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
}
